import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

// components
import { SbSharedRefineMenuInputRangeCurrency } from '../../SbSharedRefineMenu/SbSharedRefineMenuInputRange/SbSharedRefineMenuInputRangeCurrency.tsx';
import { SbSharedRefineMenuPriceRanges } from '../../SbSharedRefineMenu/SbSharedRefineMenuPriceRanges/SbSharedRefineMenuPriceRanges.tsx';
import { SbSharedRefineMenuSaleInput } from '../../SbSharedRefineMenu/SbSharedRefineMenuSaleInput/SbSharedRefineMenuSaleInput.tsx';
import { SbSharedRefineMenuNetPriceTradeDiscount } from '../../SbSharedRefineMenu/SbSharedRefineMenuNetPriceTradeDiscount/SbSharedRefineMenuNetPriceTradeDiscount.tsx';

import { type SbRespRefineMenuFilterPrice_itemSearch$key } from './__generated__/SbRespRefineMenuFilterPrice_itemSearch.graphql.ts';
import { type SbRespRefineMenuFilterPrice_filters$key } from './__generated__/SbRespRefineMenuFilterPrice_filters.graphql.ts';
import { type SbRespRefineMenuFilterPrice_user$key } from './__generated__/SbRespRefineMenuFilterPrice_user.graphql.ts';

const itemSearchFragment = graphql`
    fragment SbRespRefineMenuFilterPrice_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuInputRangeCurrency_itemSearch
        ...SbSharedRefineMenuPriceRanges_itemSearch
        ...SbSharedRefineMenuSaleInput_itemSearch
        ...SbSharedRefineMenuNetPriceTradeDiscount_itemSearch
    }
`;
const filterFragment = graphql`
    fragment SbRespRefineMenuFilterPrice_filters on SearchBrowseFilter {
        ...SbSharedRefineMenuInputRangeCurrency_filters
    }
`;
const userFragment = graphql`
    fragment SbRespRefineMenuFilterPrice_user on User {
        ...SbSharedRefineMenuPriceRanges_user
    }
`;
type Props = {
    itemSearch: SbRespRefineMenuFilterPrice_itemSearch$key;
    filter: SbRespRefineMenuFilterPrice_filters$key;
    user: SbRespRefineMenuFilterPrice_user$key;
    filterName: string;
    trackingOptions?: Record<string, unknown>;
};

export const SbRespRefineMenuFilterPrice: FC<Props> = ({
    itemSearch: itemSearchRef,
    filter: filterRef,
    user: userRef,
    filterName,
    trackingOptions,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const filter = useFragment(filterFragment, filterRef);
    const user = useFragment(userFragment, userRef);

    return (
        <>
            <SbSharedRefineMenuPriceRanges
                itemSearch={itemSearch}
                user={user}
                trackingOptions={trackingOptions}
            />
            <SbSharedRefineMenuInputRangeCurrency
                itemSearch={itemSearch}
                filter={filter}
                filterName={filterName}
                showInvalidRangeErrorMessage={false}
                trackingOptions={trackingOptions}
            />

            <SbSharedRefineMenuNetPriceTradeDiscount
                itemSearch={itemSearch}
                trackingOptions={trackingOptions}
            />
            <SbSharedRefineMenuSaleInput
                itemSearch={itemSearch}
                trackingOptions={trackingOptions}
            />
        </>
    );
};
